import React from "react";
import PropTypes from "prop-types"; // Import PropTypes
import { useAuth } from "../authContext"; // Adjust the path as per your directory structure
import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }) {
	const { currentUser } = useAuth(); // useAuth hook to access currentUser directly
	
	if (!currentUser) {
		return <Navigate to="/login" replace />;
	}
	console.log(children);
	return children;
}

// Adding PropTypes validation
ProtectedRoute.propTypes = {
	children: PropTypes.node.isRequired,
};

export default ProtectedRoute;
